import { BannerPagination } from './BannerPagination'
import { withBannerPagination } from './withBannerPagination'

const ConnectedBannerPagination = withBannerPagination(BannerPagination)

export { ConnectedBannerPagination as BannerPagination }
